import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface SourceSettingsProps {
  autoCollection: boolean;
  minRelevanceScore: number;
  onAutoCollectionToggle: (enabled: boolean) => void;
  onMinRelevanceScoreChange: (score: number) => void;
  onSaveRules: () => void;
}

export const SourceSettings = ({
  autoCollection,
  minRelevanceScore,
  onAutoCollectionToggle,
  onMinRelevanceScoreChange,
  onSaveRules
}: SourceSettingsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Source Settings</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-sm font-medium">Auto-collection</p>
              <p className="text-sm text-muted-foreground">
                Automatically collect data from sources at regular intervals
              </p>
            </div>
            <Switch
              checked={autoCollection}
              onCheckedChange={onAutoCollectionToggle}
            />
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <p className="text-sm font-medium">Filtering Rules</p>
              <p className="text-sm text-muted-foreground">
                Set minimum relevance score for content collection
              </p>
            </div>
            <div className="flex gap-4 items-center">
              <Input
                type="number"
                min="0"
                max="1"
                step="0.1"
                value={minRelevanceScore}
                onChange={(e) => onMinRelevanceScoreChange(parseFloat(e.target.value))}
                className="w-32"
              />
              <Button variant="outline" onClick={onSaveRules}>
                Save Rules
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};